import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import useReportMonitorReady from '../../../../hooks/useReportMonitorReady';
import { listenInTab_AC } from '../../../../store/actions/executor.actions';
import M3SR from '../M3SR';

const GX4100: React.FunctionComponent<any> = (props) => {
  const dispatch = useDispatch();
  const reportMonitorReady = useReportMonitorReady();
  useEffect(() => {
    reportMonitorReady('gx4100');
    dispatch(listenInTab_AC());
  }, []);
  return <M3SR />;
};

export default GX4100;
